import {
  appFormUtil,
  StyledDropDown
} from 'modules';
import React from 'react';
import * as ds from './dataService';


export type SelectInstallationTypeFieldProps<T extends object> = {
  form: appFormUtil.InferReturn<T>;
  fieldName: keyof T;
  inputLabel?: string;
  disabled?: boolean;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object> (props: SelectInstallationTypeFieldProps<T>) => {
  const { data } = ds.useQuery();

  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      disabled={props.disabled}
      inputLabel={props.inputLabel && props.inputLabel}
      options={data}

    />
  );
};
